function RecommendedStrategyResolver() {
  const self = this;

  self.resolve = function (selectedStrategy, recommendedStrategies, strategies) {
    const selectedStrategyIsRecommended = recommendedStrategies[recommendedStrategies.indexOf(selectedStrategy)];
    if (selectedStrategyIsRecommended) {
      return selectedStrategy;
    }
    else {
      let selectedStrategyIndex = strategies.indexOf(selectedStrategy)
      let firstRecommendedStrategyIndex = strategies.indexOf(recommendedStrategies[0])
      let lastRecommendedStrategyIndex = strategies.indexOf(recommendedStrategies[recommendedStrategies.length - 1])
      if (selectedStrategyIndex < firstRecommendedStrategyIndex) {
        return strategies[selectedStrategyIndex + 1]
      }
      if (selectedStrategyIndex > lastRecommendedStrategyIndex) {
        return recommendedStrategies[recommendedStrategies.length - 1]
      }
    }

  }
}
